import MenuQuinzaineBilling from './MenuQuinzaineBilling.view';

export default MenuQuinzaineBilling;
